import {
  AudioRecordingModelData,
  AudioRecordingUploadStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkSkippedUploadingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_SKIPPED_UPLOADING_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    // COMPLETED is terminal and should not transition back to SKIPPED.
    if (existingData.upload_status === AudioRecordingUploadStatus.COMPLETED) {
      return {};
    }

    return {
      upload_status: AudioRecordingUploadStatus.SKIPPED,
    };
  }
}
